import { useDispatch, useSelector } from "react-redux"
import { updateData } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'

const useMainData = () => {
  const { data, mission } = useSelector(state => state.main)
  const dispatch = useDispatch()

  const loadData = (queryFields, callback = () => { }) => {
    let query = mission.isAdminPanel ? '' : `mission=${mission.id}`
    for (let field in queryFields) {
      if (!data[field] || !data[field].length) {
        query = `${query !== '' ? `${query}&${queryFields[field]}` : queryFields[field]}`
      }
    }

    if (query) {
      get(encodeURI(`${import.meta.env.VITE_API_URL}/public/datas?${query}`), response => {
        dispatch(updateData(response.datas))
        callback()
      })
    }

    return true
  }
  return loadData
}

export default useMainData